import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AnimatedComponent from "../Components/AnimatedComponent";
import { fadeInY, popOut, stagger } from "../utils/animatedVariants";
import { BrowserQRCodeReader } from "@zxing/browser";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
// Icons
import { LuQrCode } from "react-icons/lu";
import { LuUser } from "react-icons/lu";
import { FiStar } from "react-icons/fi";
import { LuHeart } from "react-icons/lu";
import { FiGift } from "react-icons/fi";
import { LuCoffee } from "react-icons/lu";
import { FiMusic } from "react-icons/fi";
import { LuGamepad2 } from "react-icons/lu";
import { LiaCarSideSolid } from "react-icons/lia";
import { LuPlane } from "react-icons/lu";
import { FiHome } from "react-icons/fi";
import { FiLoader } from "react-icons/fi"; // Spinner icon
import { FaCheck } from "react-icons/fa6";
import { RiArrowRightSLine } from "react-icons/ri";
import axios from "axios";

const icons = [
  {
    id: "user",
    icon: <LuUser />,
    svg: `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>`,
  },
  {
    id: "star",
    icon: <FiStar />,
    svg: `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`,
  },
  {
    id: "heart",
    icon: <LuHeart />,
    svg: `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path></svg>`,
  },
  {
    id: "gift",
    icon: <FiGift />,
    svg: `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>`,
  },
  {
    id: "coffee",
    icon: <LuCoffee />,
    svg: `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M17 8h1a4 4 0 1 1 0 8h-1"></path><path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z"></path><line x1="6" x2="6" y1="2" y2="4"></line><line x1="10" x2="10" y1="2" y2="4"></line><line x1="14" x2="14" y1="2" y2="4"></line></svg>`,
  },
  {
    id: "music",
    icon: <FiMusic />,
    svg: `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle></svg>`,
  },
  {
    id: "gamepad",
    icon: <LuGamepad2 />,
    svg: `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><line x1="6" x2="10" y1="11" y2="11"></line><line x1="8" x2="8" y1="9" y2="13"></line><line x1="15" x2="15.01" y1="12" y2="12"></line><line x1="18" x2="18.01" y1="10" y2="10"></line><path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z"></path></svg>`,
  },
  {
    id: "car",
    icon: <LiaCarSideSolid />,
    svg: `<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 32 32" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M 6.59375 6 C 5.257813 6 4.023438 6.667969 3.28125 7.78125 L 0.5 11.9375 C 0.171875 12.429688 0 13 0 13.59375 L 0 20.21875 C 0 21.132813 0.613281 21.933594 1.5 22.15625 L 4.09375 22.8125 C 4.46875 24.628906 6.078125 26 8 26 C 9.851563 26 11.398438 24.71875 11.84375 23 L 21.15625 23 C 21.601563 24.71875 23.148438 26 25 26 C 26.851563 26 28.398438 24.71875 28.84375 23 L 30 23 C 31.09375 23 32 22.09375 32 21 L 32 17.34375 C 32 15.511719 30.746094 13.910156 28.96875 13.46875 L 23.5625 12.09375 L 19.65625 7.4375 C 18.894531 6.527344 17.78125 6 16.59375 6 Z M 6.59375 8 L 11 8 L 11 12 L 2.875 12 L 4.9375 8.90625 L 4.9375 8.875 C 5.308594 8.316406 5.921875 8 6.59375 8 Z M 13 8 L 16.59375 8 C 17.1875 8 17.746094 8.261719 18.125 8.71875 L 20.875 12 L 13 12 Z M 2 14 L 22.875 14 L 28.5 15.40625 C 29.394531 15.628906 30 16.421875 30 17.34375 L 30 21 L 28.84375 21 C 28.398438 19.28125 26.851563 18 25 18 C 23.148438 18 21.601563 19.28125 21.15625 21 L 11.84375 21 C 11.398438 19.28125 9.851563 18 8 18 C 6.226563 18 4.738281 19.171875 4.21875 20.78125 L 2 20.21875 Z M 8 20 C 9.117188 20 10 20.882813 10 22 C 10 23.117188 9.117188 24 8 24 C 6.882813 24 6 23.117188 6 22 C 6 20.882813 6.882813 20 8 20 Z M 25 20 C 26.117188 20 27 20.882813 27 22 C 27 23.117188 26.117188 24 25 24 C 23.882813 24 23 23.117188 23 22 C 23 20.882813 23.882813 20 25 20 Z"></path></svg>`,
  },
  {
    id: "plane",
    icon: <LuPlane />,
    svg: `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"></path></svg>`,
  },
  {
    id: "home",
    icon: <FiHome />,
    svg: `<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>`,
  },
];

function Home() {
  // For QR ANd MEnual tab
  const [active, setActive] = useState("user");

  // For all Icon buttons
  const [tab, setTab] = useState("home");

  const [nickname, setNickname] = useState("");
  const [dob, setDob] = useState("");
  // For date Calender
  const [isMinor, setIsMinor] = useState(false);

  const [isScanning, setIsScanning] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [scanning, setScanning] = useState(false);
  const [showPasscode, setShowPasscode] = useState(false);
  const [qrImage, setQrImage] = useState(null); // uploaded QR image
  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [registeredData, setRegisteredData] = useState(null);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [error, setError] = useState("");

  // uploaded QR image
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setQrImage(imageUrl);

      try {
        const codeReader = new BrowserQRCodeReader();
        const result = await codeReader.decodeFromImageUrl(imageUrl);
        const data = JSON.parse(result.text);
        console.log("Scanned QR Data:", data);
        console.log("SVG:", data?.svgicon);

        // Fallback if svgicon not present
        if (!data.svgicon) {
          toast.warn("Icon not included in QR. Showing default icon.");
        }
        setQrData(data);
      } catch (err) {
        console.error("QR decode error:", err);
        setError("Invalid QR Code");
      }
    }
  };

  //
  const handleStartScan = () => {
    if (!qrData) return;
    setScanning(true); // Show green QR scanning loader

    // Simulate scanning
    setTimeout(() => {
      setIsScanning(false); // Hide scanning screen
      setIsProcessing(true); // Show processing screen
      setScanning(false); // Reset scanning state

      // After processing screen delay
      setTimeout(() => {
        setIsProcessing(false); // Hide processing screen
        setShowPasscode(true); // Show passcode screen
      }, 3000); // Processing screen visible for 3 seconds
    }, 2000); // QR scanning delay: 2 seconds
  };

  //
  useEffect(() => {
    if (nickname.trim() !== "" && active !== "" && dob && isMinor) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false);
    }
  }, [nickname, active, dob, isMinor, active]);

  // Utility to calculate 18 years before today
  const getEighteenYearsAgo = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 18);
    return today;
  };
  //
  const handleCreatePass = async () => {
    if (!nickname || !dob || !active) {
      toast.error("Please fill all fields");
      return;
    }

    const triggerDownload = (url) => {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    //
    const selectedIcon = icons.find((item) => item.id === active);
    if (!selectedIcon || !selectedIcon.svg) {
      toast.error("Selected icon is missing SVG");
      return;
    }

    try {
      const formattedDob = dob ? dob.toISOString().split("T")[0] : "";
      const response = await axios.post(
        "http://67.211.221.41:5008/api/register",
        {
          username: nickname,
          dob: formattedDob,
          svgicon: selectedIcon.svg,
        }
      );
      setRegisteredData(response.data.data);
      console.log(response.data.data, "RegisteredData");
      const { qrImageUrl } = response.data.data;

      const downloadUrl = response.data.data.qrImageUrl;

      triggerDownload(downloadUrl);
      setShowPasscode(true);
      toast.success(response.data.message);
    } catch (error) {
      console.error("Error creating pass:", error);
      toast.error("User Already Registered");
    }
  };

  return (
    <div>
      <section className="relative ">
        <div className="min-h-full w-full">
          <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 relative">
            <div className="flex items-center justify-center min-h-screen p-4 bg-[#fff7ed]">
              {/* QR Scan screen */}
              {isScanning && (
                <div
                  id="Qrscannings"
                  className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full"
                >
                  <div className="text-center mb-8">
                    <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center">
                      <LuUser className="text-[40px] text-white" />
                    </div>
                    <h1 className="text-3xl font-bold text-red-700 mb-2">
                      Stern Army
                    </h1>
                    <p className="text-gray-600">Join our premium community</p>
                  </div>
                  <div className="flex bg-gray-100 rounded-xl p-1 mb-6">
                    <button
                      onClick={() => setTab("home")}
                      className={`flex-1 justify-center py-3 px-4 rounded-lg font-medium transition-all duration-200 
                    ${
                      tab === "home"
                        ? "bg-gradient-to-r from-red-500 to-orange-500 text-white shadow-lg"
                        : "text-gray-800 hover:text-gray-800"
                    }`}
                    >
                      <LuQrCode
                        className={`text-[20px] w-full ${
                          tab === "home" ? "text-white" : "text-gray-800"
                        }`}
                      />
                      QR Scan
                    </button>

                    <button
                      onClick={() => setTab("profile")}
                      className={`flex-1 justify-center py-3 px-4 rounded-lg font-medium transition-all duration-200 
                    ${
                      tab === "profile"
                        ? "bg-gradient-to-r from-red-500 to-orange-500 text-white shadow-lg"
                        : "text-gray-800 hover:text-gray-800"
                    }`}
                    >
                      <LuUser
                        className={`text-[20px] w-full ${
                          tab === "profile" ? "text-white" : "text-gray-800"
                        }`}
                      />
                      Manual
                    </button>
                  </div>
                  <div className="space-y-6">
                    <div className="mt-4">
                      {tab === "home" && (
                        <>
                          {/* QR Box */}
                          <div
                            className={`border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center transition-all duration-300 space-y-4 ${
                              scanning
                                ? "bg-green-100 border-green-700"
                                : "bg-white"
                            }`}
                          >
                            {scanning ? (
                              // Show only loader and text while scanning
                              <div className="flex flex-col items-center space-y23">
                                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-r from-green-200  to-green-200 rounded-full flex items-center justify-center ">
                                  <FiLoader className="animate-spin text-green-500 text-[35px]" />
                                </div>
                                <span className="text-base font-medium text-green-700">
                                  Scanning QR Code...
                                </span>
                              </div>
                            ) : (
                              // Default QR Code view
                              <>
                                <div className="space-y-4 text-center">
                                  <div>
                                    {qrImage ? (
                                      <img
                                        src={qrImage}
                                        alt="Uploaded QR"
                                        className="w-20 h-20 mx-auto object-cover rounded-xl shadow-md"
                                      />
                                    ) : (
                                      <LuQrCode className="text-[50px] text-[#b91c1c] inline" />
                                    )}
                                  </div>

                                  <div>
                                    <label className="inline-block mb-2 cursor-pointer font-semibold text-gray-800 bg-[#edf2f7] px-4 py-2 rounded-lg transition-all duration-200">
                                      {qrImage
                                        ? "Re-upload QR Code"
                                        : "Upload QR Code"}
                                      <input
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        onChange={handleFileChange}
                                      />
                                    </label>
                                    <p className="text-gray-600 text-sm">
                                      Position QR code within the frame to scan
                                    </p>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                          <button
                            onClick={handleStartScan}
                            className="w-full mt-6 py-4 px-6 rounded-xl font-bold text-white transition-all duration-200 bg-gradient-to-r from-red-500 to-orange-500 hover:opacity-90 shadow-lg hover:shadow-xl"
                          >
                            Start Scanning
                          </button>
                          {error && (
                            <p className="text-red-500 text-sm mt-2">{error}</p>
                          )}
                        </>
                      )}
                      {tab === "profile" && (
                        <div className="space-y-6">
                          <div>
                            <label className="block text-left text-[13px] font-semibold text-[#374151] mb-2">
                              Nickname *
                            </label>
                            <input
                              className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200"
                              placeholder="Enter your nickname"
                              type="text"
                              value={nickname}
                              onChange={(e) => setNickname(e.target.value)}
                            />
                          </div>
                          <div>
                            <label className="block text-left text-[13px] font-semibold text-[#374151] mb-3">
                              Choose Your Icon
                            </label>
                            <div className="grid grid-cols-5 gap-3">
                              {icons.map(({ id, icon }) => (
                                <button
                                  key={id}
                                  onClick={() => setActive(id)}
                                  className={`aspect-square p-3 rounded-xl border-2 transition-all duration-200 ${
                                    active === id
                                      ? "border-purple-500 bg-gradient-to-r from-red-500 to-orange-500"
                                      : "border-gray-200 bg-white hover:border-gray-300"
                                  }`}
                                >
                                  <div
                                    className={`text-[40px] w-full text-center ${
                                      active === id
                                        ? "text-white"
                                        : "text-[#4b5563]"
                                    }`}
                                  >
                                    {icon}
                                  </div>
                                </button>
                              ))}
                            </div>
                          </div>

                          <div className="space-y-4">
                            {/* Checkbox */}
                            <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-xl">
                              <input
                                id="isMinor"
                                className="!w-5 !h-5 text-purple-600 rounded"
                                type="checkbox"
                                checked={isMinor}
                                onChange={() => setIsMinor(!isMinor)}
                              />
                              <label
                                htmlFor="isMinor"
                                className="text-sm text-[#374151] flex-1 text-left"
                              >
                                I am under 18 years old
                              </label>
                            </div>

                            {/* Calendar input shown only if checkbox is checked */}
                            {isMinor && (
                              <div>
                                <label className="block text-sm font-medium text-[#374151] mb-2 text-left">
                                  Birthday *
                                </label>
                                <DatePicker
                                  selected={dob}
                                  onChange={(date) => setDob(date)}
                                  dateFormat="yyyy-MM-dd"
                                  maxDate={getEighteenYearsAgo()}
                                  placeholderText="Select your DOB"
                                  showYearDropdown
                                  scrollableYearDropdown
                                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:!ring-0  focus:!border-transparent transition-all duration-200"
                                />
                              </div>
                            )}
                          </div>

                          <button
                            disabled={!isButtonEnabled}
                            onClick={handleCreatePass}
                            className={`w-full flex gap-2 justify-center items-center py-4 px-6 rounded-xl font-bold text-white transition-all duration-200 ${
                              isButtonEnabled
                                ? "bg-gradient-to-r from-red-500 to-orange-500 hover:opacity-90"
                                : "bg-gray-400 cursor-not-allowed"
                            }`}
                          >
                            Create My Pass
                            <RiArrowRightSLine className="text-[22px] text-white" />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {/* Processing Screen */}
              {isProcessing && (
                <div className="fixed inset-0 bg-opacity-90 z-50 flex items-center justify-center ">
                  <div
                    id="ProcessingScreen"
                    className="bg-white rounded-3xl shadow-2xl p-8 max-w-sm w-full text-center"
                  >
                    <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center">
                      <FiLoader className="animate-spin text-white text-[35px]" />
                    </div>

                    <div>
                      <h3 className="text-[18px] font-bold text-red-700 mb-2">
                        Processing...
                      </h3>
                      <p className="text-gray-600 text-[13px] mb-4">
                        Creating your personalized experience...
                      </p>

                      <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
                        <div className="bg-red-600 h-2.5 animate-pulse w-[80%]"></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/*Pass Creation */}
              {showPasscode && qrData && (
                <div className="fixed inset-0 bg-opacity-90 z-50 flex items-center justify-center ">
                  <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-lg w-full">
                    <div className="text-center mb-8">
                      <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center">
                        <FaCheck className="text-[30px] text-white" />
                      </div>
                      <h2 className="text-3xl font-bold text-red-700">
                        Pass Creation
                      </h2>
                      <p className="text-gray-600 mt-2">
                        Welcome to Stern Army!
                      </p>
                    </div>
                    <div className="bg-gradient-to-r from-red-500 to-orange-500 rounded-2xl p-6 mb-6 text-white relative overflow-hidden">
                      <div className="absolute inset-0 opacity-10">
                        <div className="grid grid-cols-8 gap-2 h-full">
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                          <div className="bg-white rounded-full aspect-square"></div>
                        </div>
                      </div>
                      <div className="relative z-10">
                        <div className="flex justify-between items-start mb-6 text-left">
                          <div>
                            <h3 className="text-lg font-bold">Stern Army</h3>
                            <p className="text-sm opacity-90">Premium Member</p>
                          </div>
                          {qrData?.svgicon ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: qrData.svgicon,
                              }}
                              className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center"
                            />
                          ) : (
                            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                              <LuUser className="text-[30px] text-white" />
                            </div>
                          )}
                        </div>
                        <div className="grid grid-cols-2 gap-4 mb-6 text-left">
                          <div>
                            <p className="text-xs opacity-75">Member ID</p>
                            <p className="font-mono text-sm">
                              {qrData.membershipId}
                            </p>
                          </div>
                          <div>
                            <p className="text-xs opacity-75">Member No.</p>
                            <p className="font-mono text-sm">1464</p>
                          </div>
                          <div>
                            <p className="text-xs opacity-75">Nickname</p>
                            <p className="text-sm font-medium">
                              {qrData.username}
                            </p>
                          </div>
                          <div>
                            <p className="text-xs opacity-75">Birthday</p>
                            <p className="text-sm">{qrData.dob}</p>
                          </div>
                        </div>
                        <div className="bg-yellow-400 rounded-lg p-3 flex items-center justify-center gap-2 text-[#000000]">
                          <LuQrCode className="text-[25px]" />
                          <span className="text-black font-bold">QR CODE</span>
                        </div>
                      </div>
                    </div>
                    <div className="space-y-3">
                      <button className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-3 px-6 rounded-xl transition-colors duration-200 text-[#000000]">
                        Show My CODE
                      </button>
                      <button className="w-full bg-gradient-to-r from-red-500 to-orange-500 hover:opacity-90 text-white font-bold py-3 px-6 rounded-xl transition-opacity duration-200">
                        We're here
                      </button>
                      {/* <button class="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-xl transition-colors duration-200">Create Another Pass</button> */}
                      <button
                        onClick={() => {
                          setIsScanning(true); // Show QR scanning screen
                          setIsProcessing(false); // Hide processing screen
                          setShowPasscode(false); // Hide passcode screen
                          setTab("home"); // Optional: reset tab to QR Scan view
                          setQrImage(null); // Optional: reset uploaded QR
                          setScanning(false); // Optional: reset scanning animation
                          setQrData(null);
                          setError("");
                        }}
                        className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-6 rounded-xl transition-colors duration-200"
                      >
                        Create Another Pass
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
